import olms, {apply, applyBackground, applyStyle} from './index.js';
import stylefunction from './stylefunction.js';
import {assign} from './util.js';

assign(olms, {apply, applyBackground, applyStyle, stylefunction});

export default olms;
